import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'zui-recipe',
  templateUrl: './recipe.component.html',
  styleUrls: [ './recipe.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipeComponent {

  devEnv = true;
  prodEnv = false;

  @Input()
  structure: string;

  @Input()
  id: string;

  @Input()
  projectImportLoading = false;

  @Input()
  guideSlug: string;

  @Input()
  priceNonha: string;

  @Input()
  priceHa: string;

  @Input()
  resourcesNonha: string;

  @Input()
  resourcesHa: string;

  @Output()
  importProjectClicked = new EventEmitter<{
    ref: HTMLElement;
    prodEnv: boolean;
    devEnv: boolean;
  }>();

  @Output()
  showProjectYamlClicked = new EventEmitter<{
    id: string;
    mode: 'ha' | 'non-ha';
  }>();

  trackBy(index: number) {
    return index;
  }

}
